<template>
  <v-layout row justify-center>
    <v-dialog v-model="dialog" persistent max-width="600px" @keydown="checkEsc">
      <v-card>
        <v-card-title>
          <span class="headline">{{ headline }}</span>
        </v-card-title>
        <v-card-text>
          <div class="input-holder d-flex search-holder" ref="inputHolder">
            <v-textarea
              :label="globalTexts.recommendation"
              v-model="textValue"
              @keyup.enter="addText"
              autofocus
              rows="3"
            ></v-textarea>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="cancel">{{ $t('global.close') }}</v-btn>
          <v-btn flat @click="addText">{{ $t('global.add') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import i18n from '@/plugins/i18n'

export default {
  name: 'AddTextDialog',
  data: () => ({
    dialog: false,
    textValue: '',
    headline: '',
  }),
  computed: {
    globalTexts: function() {
      return i18n.messages[i18n.locale].global
    },
  },
  methods: {
    show(textValue, headline) {
      this.headline = this.globalTexts.recommendation
      this.$nextTick(() => {
        this.dialog = true
        if (textValue) {
          this.textValue = textValue
        }
        if (headline) {
          this.headline = headline
        }
        this.inputFocus()
      })
    },
    addText() {
      this.dialog = false
      this.$emit('addTextItem', this.textValue)
      this.textValue = ''
    },
    cancel() {
      this.textValue = ''
      this.dialog = false
    },
    checkEsc(ev) {
      if (ev.keyCode === 27) {
        this.dialog = false
        this.textValue = ''
      }
    },
    inputFocus() {
      const inputHolder = this.$refs.inputHolder
      if (inputHolder) {
        const input = inputHolder.querySelector('input')
        if (input) {
          this.$nextTick(() => input.focus())
        }
      }
    },
  },
}
</script>
